<template>
  <div style="display: flex; gap: 40px; width: 100%">
    <div v-for="column in columns" :key="column.header" class="column">
      <div class="column-header" :class="column.headerClass">{{ column.header }}</div>
      <div class="column-card">
        <div class="field">
          <div class="field-label">{{ $t('AGENTUREN.AGENTURNUMMER') }}</div>
          <div class="field-value">{{ column.data.id || '-' }}</div>
        </div>
        <div class="field" :class="{ 'field--match': agentur1.nameMatch }">
          <div class="field-label">{{ $t('REISEN.COMMON.NAME') }}</div>
          <div class="field-value">{{ column.data.name || '-' }}</div>
        </div>
        <div class="field" :class="{ 'field--match': agentur1.emailMatch }">
          <div class="field-label">{{ $t('AUTH.INPUT.EMAIL') }}</div>
          <div class="field-value">{{ column.data.email || '-' }}</div>
        </div>
        <div class="field" :class="{ 'field--match': agentur1.strasseMatch }">
          <div class="field-label">{{ $t('COMMON.STRASSE') }}</div>
          <div class="field-value">{{ column.data.strasse || '-' }}</div>
        </div>
        <div class="field" :class="{ 'field--match': agentur1.ortMatch }">
          <div class="field-label">{{ $t('COMMON.ORT') }}</div>
          <div class="field-value">{{ column.data.ort || '-' }}</div>
        </div>
        <div class="field" :class="{ 'field--match': agentur1.plzMatch }">
          <div class="field-label">{{ $t('COMMON.PLZ') }}</div>
          <div class="field-value">{{ column.data.plz || '-' }}</div>
        </div>
        <div class="field" :class="{ 'field--match': agentur1.telefonMatch }">
          <div class="field-label">{{ $t('COMMON.TELEFON') }}</div>
          <div class="field-value">{{ column.data.telefon || '-' }}</div>
        </div>
        <div class="field" :class="{ 'field--match': agentur1.steuernummerMatch }">
          <div class="field-label">{{ $t('COMMON.STEUERNUMMER') }}</div>
          <div class="field-value">{{ column.data.steuernummer || '-' }}</div>
        </div>
        <div class="field">
          <div class="field-label">{{ $t('COMMON.WARNUNG') }}</div>
          <div class="field-value">{{ column.data.warnung || '-' }}</div>
        </div>
        <div class="field">
          <div class="field-label">{{ $t('AGENTUREN.BUCHUNGSSPERRE') }}</div>
          <div class="field-value">{{ getBuchungssperre(column.data.buchungssperre) }}</div>
        </div>
        <div class="field">
          <div class="field-label">{{ $t('AGENTUREN.GESPERRTAB') }}</div>
          <div class="field-value">{{ getDate(column.data.gesperrtAb) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    agentur1: { type: Object, required: true },
    agentur2: { type: Object, required: true },
  },
  computed: {
    columns() {
      return [
        { header: 'Gefundenes Duplikat I', headerClass: 'column-header--yellow', data: this.agentur1 },
        { header: 'Gefundenes Duplikat II', headerClass: 'column-header--yellow', data: this.agentur2 },
      ];
    },
  },
  methods: {
    getBuchungssperre(buchungssperre) {
      return buchungssperre === null ? '-' : buchungssperre ? this.$t('COMMON.JA') : this.$t('COMMON.NEIN');
    },
    getDate(date) {
      return date === null ? '-' : this.$options.filters.date(date);
    },
  },
};
</script>

<style lang="scss" scoped>
.column {
  flex: 1;
  min-width: 0;
}

.column-header {
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 24px 16px;
  border-radius: var(--radius-md);
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 16px;

  &--yellow {
    background-color: #fffbeb;
    color: #973c00;
    border: 1px solid #ffc107;
  }
}

.column-card {
  border: 0.5px solid var(--border);
  border-radius: var(--radius-md);
  padding: 24px;
  background-color: var(--surface);
  box-shadow: 0px 1px 3px 0px #0000001a;
}

.field {
  margin-bottom: 8px;
}

.field-label {
  font-size: 12px;
  font-weight: 400;
  color: var(--text-muted);
  margin-bottom: 8px;
  text-transform: uppercase;
}

.field-value {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 15px;
  font-weight: 600;
  color: var(--text);
}

.field--match {
  background-color: rgba(#1bc5bd, 0.1);
  border-radius: 4px;
  padding: 2px 0px;
}
</style>
